// DeleteStaff.tsx
import React from "react";
import { Modal } from "@mantine/core";
import { Button, Title, Group } from "@mantine/core";
import classes from "./delete.module.css";

interface DeleteStaffProps {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteStaff: React.FC<DeleteStaffProps> = ({
  isVisible,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal opened={isVisible} onClose={onClose}>
      <Title className={classes.title} order={4}>
        Are you sure you want to delete this item?
      </Title>
      <Group className={classes.buttonPart}>
        <Button onClick={onClose} className={classes.buttonCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm} className={classes.buttonDelete}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteStaff;
